import React from 'react';
import {links} from '../index';
export const Contact = (props) => {
	return (
		<section
			id='contact-section'
			className='contact section'
        >
			<h2 className='contact-header section-header'>
				Contact
			</h2>
			<div className='contact-container'>
				<div className='contact-text-container'>
					<p>Interested in collaborating with me? I'd love to chat!</p>
				</div>
				<a
					className='contact-email btn-ripple'
					href={`mailto:${links.email}`}
                >
					<div className='ripple'></div>
                    {links.email}
				</a>
				<ul className='contact-list'>
					<li>
						<a
							href={links.gitlab}
							target='_blank'
							rel='noopener noreferrer'
							className='contact-link btn-ripple'
                            title='Gitlab'
                        >
							<div className='ripple'></div>
							<i className='fab fa-gitlab' aria-label='Gitlab'></i>
						</a>
					</li>
					<li>
						<a
							href={links.linkedin}
							target='_blank'
							rel='noopener noreferrer'
							className='contact-link contact-linkedin btn-ripple'
                            title='LinkedIn'
                        >
							<div className='ripple'></div>
							<i className='fab fa-linkedin-in' aria-label='LinkedIn'></i>
						</a>
					</li>
					<li>
						<a
							href={links.codepen}
							target='_blank'
							rel='noopener noreferrer'
							className='contact-link btn-ripple'
                            title='Codepen'
                        >
							<div className='ripple'></div>
							<i className='fab fa-codepen' aria-label='Codepen'></i>
						</a>
					</li>
				</ul>
			</div>
		</section>
	);
};
